module.exports = __webpack_public_path__ + "static/media/GTEestiDisplay-Light.263724a7.woff2";